import React, {PropTypes} from 'react';


function DocumentIcon(props) {
  const {
    className,
    ...otherProps
  } = props;

  return (
    <svg width="30px" height="30px" viewBox="0 0 30 30" version='1.1' xmlns='http://www.w3.org/2000/svg' className={`profile-icon ${className}`} {...otherProps}>
      <g id="1160---Upload-of-Assessment-Scores" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-866.000000, -438.000000)" id="Group-38-Copy" fill="#4A4A4A">
            <g transform="translate(866.000000, 438.000000)">
                <path d="M15,30 C6.729,30 0,23.271 0,15 C0,6.729 6.729,0 15,0 C23.271,0 30,6.729 30,15 C30,23.271 23.271,30 15,30 L15,30 Z M15,2 C7.832,2 2,7.832 2,15 C2,22.168 7.832,28 15,28 C22.168,28 28,22.168 28,15 C28,7.832 22.168,2 15,2 L15,2 Z" id="Shape"></path>
                <g id="icon_blank-file" transform="translate(10.000000, 8.000000)" strokeWidth="0.4" stroke="#4A4A4A">
                    <g id="Icons">
                        <g id="Group">
                            <path d="M10.5416667,14 L0.458333333,14 C0.205333333,14 0,13.804 0,13.5625 L0,0.4375 C0,0.196 0.205333333,0 0.458333333,0 L6.77966667,0 C6.90433333,0 7.02395833,0.0485625 7.110125,0.1343125 L10.872125,3.8714375 C10.9541667,3.9528125 11,4.06175 11,4.174625 L11,13.5625 C11,13.804 10.7946667,14 10.5416667,14 L10.5416667,14 Z M0.916666667,13.125 L10.0833333,13.125 L10.0833333,4.3505 L6.58441667,0.875 L0.916666667,0.875 L0.916666667,13.125 L0.916666667,13.125 Z" id="Shape"></path>
                            <path d="M10.125,5.375 L6.45833333,5.375 C6.20533333,5.375 6,5.179 6,4.9375 L6,1.4375 C6,1.196 6.20533333,1 6.45833333,1 C6.71133333,1 6.91666667,1.196 6.91666667,1.4375 L6.91666667,4.5 L10.125,4.5 C10.378,4.5 10.5833333,4.696 10.5833333,4.9375 C10.5833333,5.179 10.378,5.375 10.125,5.375 L10.125,5.375 Z" id="Shape"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
    </svg>
  );
}


DocumentIcon.propTypes = {
  className: PropTypes.string
};

export default DocumentIcon;



// WEBPACK FOOTER //
// ./shared/common/svgs/DocumentIcon/index.js